import { App } from 'vue';
import DynamicForm from '@/form/DynamicForm.vue';
import FormInput from '@/form/FormInput.vue';
import FormTextarea from '@/form/FormTextarea.vue';
import FormDropdown from '@/form/FormDropdown/FormDropdown.vue';
import FormCheckbox from '@/form/FormCheckbox.vue';
import FormCheckList from '@/form/FormCheckList.vue';
import FormFieldGroup from '@/form/FormFieldGroup.vue';
import FormAutoComplete from '@/form/FormAutoComplete/FormAutoComplete.vue';
import FormUpload from '@/form/FormUpload.vue';
import FormDatepicker from '@/form/FormDatepicker/index.vue';

export default {
  install(Vue: App) {
    Vue.component('DynamicForm', DynamicForm);
    Vue.component('FormInput', FormInput);
    Vue.component('FormTextarea', FormTextarea);
    Vue.component('FormDropdown', FormDropdown);
    Vue.component('FormCheckbox', FormCheckbox);
    Vue.component('FormCheckList', FormCheckList);
    Vue.component('FormFieldGroup', FormFieldGroup);
    Vue.component('FormAutoComplete', FormAutoComplete);
    Vue.component('FormUpload', FormUpload);
    Vue.component('FormDate', FormDatepicker);
  },
};
